<div class="max-w-[90vw] min-w-[60vw]">
        
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
        <div class="text-lg font-medium">Create New Quote</div>
        <button
            mat-icon-button
            (click)="close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>


    
    <div class="mt-12 max-h-[calc(100vh-170px)] overflow-y-scroll px-1">

        <mat-horizontal-stepper
            [linear]="isLinear"
            labelPosition="bottom"
            #stepper
            [selectedIndex]="selectedStepIndex"
            [class.block-review-header]="!productsForm?.valid || (isLinear && isCustomQuote() && !deal?.isSentToSales)"
            [class.block-preview-header]="!summaryForm?.valid">

            <!-- Customer Details -->
            <mat-step label="Customer Details" [stepControl]="customerForm">
                <form *ngIf="customerForm" [formGroup]="customerForm" class="mt-4">
                    <div class="w-full flex flex-col gap-4">
                        
                        <!-- Order Type -->
                        <!-- <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                            <div class="grid grid-cols-3 gap-4">
                                <mat-label class="col-span-3 text-xl mt-4">Manufacture Process</mat-label>
                                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Category</mat-label>
                                    <mat-select [value]="selectedManufactureCategoryId" (selectionChange)="manufactureCategoryChanged($event)">
                                        <ng-container *ngFor="let cat of manufactureProcesses">
                                            <mat-option [value]="cat.manufactureProcessCategoryId">
                                                {{ cat.name }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Process</mat-label>
                                    <mat-select [value]="selectedManufactureProcessId" (selectionChange)="manufactureProcessChanged($event)">
                                        <ng-container *ngFor="let process of getManufactureProcesses(); trackBy: trackByFn">
                                            <mat-option [value]="process.manufactureProcessId">
                                                {{ process.name }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Product Type</mat-label>
                                    <mat-select [formControlName]="'manufactureColumnDefinitionId'"(selectionChange)="loadChosenManufactureProcess($event.value)">
                                        <ng-container *ngFor="let column of getManufactureColumns(); trackBy: trackByFn">
                                            <mat-option [value]="column.manufactureProcessColumnDefinitionId">
                                                {{ column.name }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                                <mat-label *ngIf="selectedProcess" class="col-span-3 -mt-2">Expected Build Time: {{getHoursText(getManufactureProcessTotal() / 60)}}</mat-label>
                            </div>
                        </div> -->

                        <div *ngIf="deal?.dateSinceSwimlaneChange" class="px-5 py-2 w-full flex gap-4 justify-between">
                            <div class="flex" [class.text-red-600]="slaDate && now > slaDate">
                                <mat-icon class="icon-size-6 mr-2" [svgIcon]="'mat_outline:timer'"></mat-icon>
                                <span class="text-lg">
                                    Moved to Swimlane: {{deal.dateSinceSwimlaneChange | date: 'd MMM, yyyy'}}
                                    <br/>{{getDaysInSwimlane()}} ago
                                </span>
                            </div>
                            <div *ngIf="slaDate" class="flex" [class.text-red-600]="slaDate && now > slaDate">
                                <mat-icon class="icon-size-6 mr-2" [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                                <span class="text-lg">SLA: {{slaDate | date:'d MMM, yyyy'}} ({{getSlaDays()}} day{{getSlaDays() == 1 ? '' : 's'}})</span>
                            </div>
                        </div>

                        <!-- Quote Information -->
                        <div class="border rounded-2xl p-5 grid sm:grid-cols-4 gap-x-6 gap-y-4 w-full bg-[#f8f8f8]">
                            <div class="col-span-2 text-xl">Quote Overview</div>

                            <mat-form-field class="sm:col-span-4 fuse-mat-dense" subscriptSizing="dynamic" floatLabel="always">
                                <mat-label>Quote Title</mat-label>
                                <input
                                    (change)="customerForm?.valid && save(true, false, deal?.isWizardInFirstStage)"
                                    matInput
                                    [formControlName]="'name'"
                                    placeholder="Quote title will be automatically generated from Quote Ref, Company Name and Customer Ref">
                            </mat-form-field>

                            <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                <mat-label>Quote Ref</mat-label>
                                <input
                                    disabled
                                    [value]="deal?.quoteNumber || deal?.quoteRef || ''"
                                    matInput>
                            </mat-form-field>

                            <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                <mat-label>Customer Ref</mat-label>
                                <input
                                    (change)="regenTitle() && customerForm?.valid && save(true, false, deal?.isWizardInFirstStage)"
                                    [formControlName]="'customerReqNo'"
                                    matInput>
                            </mat-form-field>
                            
                            <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                                <mat-label>Category</mat-label>
                                <mat-select multiple [formControlName]="'dealCategories'">
                                    <ng-container *ngFor="let category of categories">
                                        <mat-option [value]="category.value" (onSelectionChange)="onCategoryToggled($event, category.value)">
                                            {{ category.name }}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                            
                            <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                <mat-label>Expected Close Date</mat-label>
                                <input
                                    (dateChange)="customerForm?.valid && save(true, false, deal?.isWizardInFirstStage)"
                                    [formControlName]="'expectedCloseDate'"
                                    [matDatepicker]="closePicker"
                                    matInput>
                                <mat-datepicker-toggle matIconSuffix [for]="closePicker"></mat-datepicker-toggle>
                                <mat-datepicker #closePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        
                        <!-- Customer Information -->
                        <div class="border rounded-2xl p-5 grid sm:grid-cols-2 gap-x-6 gap-y-4 w-full bg-[#f8f8f8]">
                            <div class="col-span-2 text-xl">Customer Information</div>

                            <div class="flex gap-4">
                                <mat-form-field class="flex-auto col-span-2 fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Customer Name*</mat-label>
                                    <input
                                        matInput
                                        [matAutocomplete]="auto"
                                        [value]="selectedCompanyName"
                                        (input)="filterCompanies($event)">
                                    <mat-autocomplete #auto="matAutocomplete">
                                        <ng-container *ngFor="let company of filteredCompanies">
                                            <mat-option [value]="company.name" (onSelectionChange)="onCompanySelected(company)">
                                                {{ company.name }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <div class="mt-auto">
                                    <button mat-flat-button color="primary">
                                        <mat-icon class="icon-size-4 mr-1" svgIcon="heroicons_outline:receipt-refund"></mat-icon>
                                        <span class="ml-1" (click)="openPastOrders()">View Orders</span>
                                    </button>
                                </div>
                            </div>
                            
                            <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                <mat-label>Contact</mat-label>
                                <mat-select
                                    (selectionChange)="customerForm?.valid && save(true, false, deal?.isWizardInFirstStage)"
                                    [formControlName]="'contactId'"
                                    #contactSelect="matSelect">
                                    <ng-container *ngFor="let contact of getCompanyContacts(); trackBy: trackByFn">
                                        <mat-option [value]="contact?.id">
                                            {{ contact?.name }}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>

                            <div>
                                <mat-label>Email Address</mat-label>
                                <div class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center">
                                    {{getContactEmail()}}
                                </div>
                            </div>

                            <div>
                                <mat-label>Phone Number</mat-label>
                                <div class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center">
                                    {{getContactPhoneNumber()}}
                                </div>
                            </div>

                            <mat-form-field class="col-span-2 fuse-mat-dense" subscriptSizing="dynamic">
                                <mat-label>Invoicing Address / VAT Rate</mat-label>
                                <mat-select
                                    [formControlName]="'invoiceAddressId'"
                                    (selectionChange)="onCompanyInvoiceAddressChange($event)">
                                    <ng-container *ngFor="let address of getCompanyInvoiceAddresses(); trackBy: trackByFn">
                                        <mat-option [value]="address.customerAddressId">
                                            {{ address.addressOne }} - {{address.vatRate * 100 | number: '1.0'}}%
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>

                            <div class="col-span-2">
                                <mat-label>Street Address</mat-label>
                                <div class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center">
                                    {{getCompany()?.address}}
                                </div>
                            </div>

                            <div>
                                <mat-label>City</mat-label>
                                <div class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center">
                                </div>
                            </div>
                            
                            <div>
                                <mat-label>State/County</mat-label>
                                <div class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center">
                                </div>
                            </div>
                            
                            <div>
                                <mat-label>Postal Code</mat-label>
                                <div class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center">
                                    {{getCompany()?.postcode}}
                                </div>
                            </div>
                            
                            <div>
                                <mat-label>Country</mat-label>
                                <div class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center">
                                </div>
                            </div>
                            
                            <mat-form-field class="col-span-2 fuse-mat-dense" subscriptSizing="dynamic">
                                <mat-label>Notes</mat-label>
                                <textarea
                                    (change)="customerForm?.valid && save(true, false, deal?.isWizardInFirstStage)"
                                    matInput
                                    [formControlName]="'notes'"
                                    [rows]="2"
                                    cdkTextareaAutosize
                                    [cdkAutosizeMinRows]="2">
                                </textarea>
                            </mat-form-field>
                        </div>

                        <!-- Attachments -->
                        <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                            <div class="text-xl">Attachments</div>
                            <div class="w-full flex flex-row flex-0 overflow-x-auto overflow-y-hidden" style="height:102px;">                
                                <div> <!--class="-ml-2"-->
                                    <!-- Upload file -->
                                    <button mat-icon-button
                                    (click)="openFileUpload()">
                                        <mat-icon
                                            class="icon-size-5"
                                            [svgIcon]="'heroicons_solid:paper-clip'"></mat-icon>
                                    </button>
                                </div>

                                <!-- Files -->
                                <ng-container *ngIf="fileInfos?.length > 0">
                                    <ng-container *ngFor="let file of fileInfos">
                                        <div *ngIf="!file.isBom" class="file-container p-2 mx-1">
                                            <!-- Icons -->
                                            <div [class.cursor-pointer]="dealId" class="relative text-center" (click)="dealId && download(file)">
                                                <div class="inline-block relative text-center">
                                                    <mat-icon
                                                        class="icon-size-14 text-hint opacity-50"
                                                        [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                                    <div
                                                        class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                                                        [class.bg-red-600]="file.type == '.pdf'"
                                                        [class.bg-blue-600]="file.type == '.doc'"
                                                        [class.bg-green-600]="file.type == '.xls'"
                                                        [class.bg-gray-600]="file.type == '.txt'"
                                                        [class.bg-amber-600]="file.type == '.jpg'"
                                                        [class.bg-yellow-500]="file.type == '.png'">
                                                        {{file.type.toUpperCase()}}
                                                    </div>
                                                    <button *ngIf="!isBasic" class="absolute" (click)="deleteFile(file, $event)">
                                                        <mat-icon class="icon-size-2 text-red-600">close</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div [class.cursor-pointer]="dealId" class="file-name text-s text-center mt-1" (click)="dealId && download(file)">{{file.name}}</div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>

                        <!-- History / Activity Log -->
                        <div *ngIf="dealId" class="border rounded-2xl p-5 flex flex-col w-full bg-[#f8f8f8]">
                            <div class="text-xl">History</div>
                            <ng-container *ngFor="let history of deal?.history">
                                <div class="italic whitespace-pre-line mt-6" [innerHTML]="history.description">
                                </div>
                                <div class="text-sm mt-2" style="color: black;">
                                    {{ history.timeStamp | date:'d MMM yyyy, h:mm a' }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!deal?.history?.length">
                                No activity logs found.
                            </ng-container>
                        </div>

                        <div class="flex justify-end gap-4">
                            <button
                                *ngIf="(!dealId || deal?.isWizardInProgress) && !deal?.isWizardInFirstStage"
                                class="ml-auto"
                                (click)="save(true, true, true)"
                                mat-stroked-button
                                type="button"
                                [disabled]="!customerForm?.valid">
                                Save Progress
                            </button>
                            <button
                                mat-flat-button
                                matStepperNext
                                type="button"
                                [color]="'primary'"
                                [disabled]="!customerForm?.valid">
                                Next
                            </button>
                        </div>

                    </div>
                </form>
            </mat-step>

            <!-- Products Step -->
            <mat-step [label]="isCustomQuote() ? 'Build Product' : getDealType() == DealType.Calibration ? 'Select Loadcells' : getDealType() == DealType.Hire ? 'Select Assets' : getDealType() == DealType.Marine ? 'Add Line Items' : 'Select Products'" [stepControl]="productsForm">
                <div class="w-full flex flex-col gap-4">

                    <div class="mt-4 border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                        <div class="text-xl">Order Type</div>

                        <mat-radio-group [value]="getOrderType()" (change)="changeQuoteType($event)" class="grid grid-cols-6 gap-4" color="primary">
                            <mat-radio-button [value]="0" class="border border-2 rounded-lg p-3 bg-white cursor-pointer" [class.border-[var(--fuse-primary)]]="getDealType() == DealType.Standard" (click)="changeQuoteType({value: 0})">
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Standard Product</div>
                                    <div class="text-sm leading-[1]">From product register</div>
                                </div>
                            </mat-radio-button>
                            <mat-radio-button [value]="1" class="border border-2 rounded-lg p-3 bg-white cursor-pointer" [class.border-[var(--fuse-primary)]]="getDealType() == DealType.RepeatCustom" (click)="changeQuoteType({value: 1})">
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Repeat Custom</div>
                                    <div class="text-sm leading-[1]">Previously built product</div>
                                </div>
                            </mat-radio-button>
                            <mat-radio-button [value]="2" class="border border-2 rounded-lg p-3 bg-white cursor-pointer" [class.border-[var(--fuse-primary)]]="getDealType() == DealType.Custom" (click)="changeQuoteType({value: 2})">
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Custom Product</div>
                                    <div class="text-sm leading-[1]">Bespoke configuration</div>
                                </div>
                            </mat-radio-button>

                            <mat-radio-button [value]="3" class="border border-2 rounded-lg p-3 bg-white cursor-pointer" [class.border-[var(--fuse-primary)]]="getDealType() == DealType.Calibration" (click)="changeQuoteType({value: 3})">
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Calibration Quote</div>
                                    <div class="text-sm leading-[1]">Calibrate loadcells</div>
                                </div>
                            </mat-radio-button>
                            <mat-radio-button [value]="4" class="border border-2 rounded-lg p-3 bg-white cursor-pointer" [class.border-[var(--fuse-primary)]]="getDealType() == DealType.Hire" (click)="changeQuoteType({value: 4})">
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Hire</div>
                                    <div class="text-sm leading-[1]">Hire assets</div>
                                </div>
                            </mat-radio-button>
                            <mat-radio-button [value]="5" class="border border-2 rounded-lg p-3 bg-white cursor-pointer" [class.border-[var(--fuse-primary)]]="getDealType() == DealType.Marine" (click)="changeQuoteType({value: 5})">
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Marine Sales</div>
                                    <div class="text-sm leading-[1]">Custom marine products</div>
                                </div>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    
                    <div class="border rounded-2xl p-5 gap-4 w-full bg-[#f8f8f8] grid grid-cols-5">
                        <div class="col-span-5 flex justify-between">
                            <div class="text-xl">{{isCustomQuote() ? 'Build Custom Product' : getDealType() == DealType.Calibration ? 'Select Loadcells' : getDealType() == DealType.Hire ? 'Select Assets' : getDealType() == DealType.Marine ? 'Add Line Items' : 'Select Products'}}</div>
                            <input
                                *ngIf="getDealType() == DealType.Standard || getDealType() == DealType.Hire || getDealType() == DealType.RepeatCustom || getDealType() == DealType.Calibration"
                                matInput
                                [placeholder]="isCustomQuote() ? 'Search parts...' : getDealType() == DealType.Calibration ? 'Search loadcells...' : getDealType() == DealType.Hire ? 'Search assets...' : 'Search products...'"
                                class="h-[42px] border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                (input)="isCustomQuote() ? filterParts($event) : getDealType() == DealType.Calibration ? filterLoadcells($event) : getDealType() == DealType.Hire ? filterAssets($event) : filterProducts($event)">
                            
                            <div *ngIf="isCustomQuote()" class="flex items-center gap-2">
                                <span>Product Name:</span>
                                <input
                                    matInput
                                    [placeholder]="'New Product Name'"
                                    class="h-[42px] border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center min-w-[300px]"
                                    [(ngModel)]="customProductName">
                                <span class="ml-2">Product Number:</span>
                                <input
                                    matInput
                                    disabled
                                    readonly
                                    [placeholder]="'New Product Number'"
                                    class="h-[42px] border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center w-[120px]"
                                    style="color: #00000061 !important"
                                    [(ngModel)]="customProductPartNumber">
                            </div>
                        </div>

                        <!-- Product/Part Register -->
                        <div *ngIf="getDealType() == DealType.Standard || getDealType() == DealType.Hire || getDealType() == DealType.RepeatCustom || getDealType() == DealType.Calibration" class="border rounded-xl bg-white col-span-2 p-4">
                            <div>{{isCustomQuote() ? 'Part' : getDealType() == DealType.Calibration ? 'Loadcell' : getDealType() == DealType.Hire ? 'Asset' : 'Product'}} Register</div>

                            <div class="flex flex-col gap-2 py-3 h-[calc(100vh-690px)] overflow-y-scroll" cdkScrollable (scroll)="onScroll($event)" style="scrollbar-gutter: stable;">
                                <!-- Products -->
                                <ng-container *ngIf="getDealType() == DealType.Standard || getDealType() == DealType.RepeatCustom">
                                    <ng-container *ngFor="let product of filteredProducts; trackBy: trackByFn">
                                        <div class="border rounded-md p-3 flex gap-2 items-center">
                                            <div class="flex-auto">
                                                <div class="flex gap-4 mb-1 items-center">
                                                    <div>{{product.partNumber}}</div>
                                                    <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{product.freeStock}} in stock</div>
                                                </div>
                                                <div class="text-md">{{product.description}}</div>
                                            </div>
                                            <div>
                                                <button mat-stroked-button (click)="openProductOverview(product)">Overview</button>
                                            </div>
                                            <div class="flex items-center">
                                                <button *ngIf="!productIsSelected(product)" mat-flat-button color="primary" (click)="addProduct(product)">Add</button>
                                                <mat-icon *ngIf="productIsSelected(product)" class="text-green-500 icon-size-4 ml-1" svgIcon="feather:check"></mat-icon>
                                                <span *ngIf="productIsSelected(product)" class="ml-1 text-green-500 text-md">Added</span>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                
                                <!-- Parts -->
                                <ng-container *ngIf="isCustomQuote()">
                                    <ng-container *ngFor="let part of filteredParts; trackBy: trackByFn">
                                        <div class="border rounded-md p-3 flex gap-2 items-center">
                                            <div class="flex-auto">
                                                <div class="flex gap-4 mb-1 items-center">
                                                    <div class="flex gap-1 items-center">
                                                        <span>{{part.number}}</span>
                                                        <mat-icon *ngIf="part.isHighRisk" [matTooltip]="'High Risk'"          color="warn" class="icon-size-5 m-0" svgIcon="mat_solid:warning"></mat-icon>
                                                        <mat-icon *ngIf="part.isCritical" [matTooltip]="'Critical Component'" color="warn" class="icon-size-5 m-0" svgIcon="mat_solid:flag"></mat-icon>
                                                        <mat-icon *ngIf="part.currentStock < part.minimumStock" [matTooltip]="'Stock under Minimum'" color="warn" class="icon-size-5" svgIcon="mat_solid:remove_shopping_cart"></mat-icon>
                                                    </div>
                                                    <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{part.currentStock}} in stock</div>
                                                </div>
                                                <div class="text-md">{{part.description}}</div>
                                            </div>
                                            <div>
                                                <button mat-stroked-button>Overview</button>
                                            </div>
                                            <div class="flex items-center">
                                                <button *ngIf="!partIsSelected(part)" mat-flat-button color="primary" (click)="addPart(part)">Add</button>
                                                <mat-icon *ngIf="partIsSelected(part)" class="text-green-500 icon-size-4 ml-1" svgIcon="feather:check"></mat-icon>
                                                <span *ngIf="partIsSelected(part)" class="text-green-500 text-md">Added</span>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                
                                <!-- Loadcells -->
                                <ng-container *ngIf="getDealType() == DealType.Calibration">
                                    <ng-container *ngFor="let loadcell of filteredLoadcells; trackBy: trackByFn">
                                        <div class="border rounded-md p-3 flex gap-2 items-center">
                                            <div class="flex-auto">
                                                <div class="flex gap-4 mb-1 items-center">
                                                    <div class="flex gap-1 items-center">
                                                        <span>{{loadcell.bookingRef}}</span>
                                                    </div>
                                                    <!-- <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{part.currentStock}} in stock</div> -->
                                                </div>
                                                <div class="text-md">{{loadcell.customerName}}</div>
                                            </div>
                                            <div>
                                                <button mat-stroked-button (click)="openLoadcellOverview(loadcell.loadcellId)">Overview</button>
                                            </div>
                                            <div class="flex items-center">
                                                <button *ngIf="!loadcellIsSelected(loadcell)" mat-flat-button color="primary" (click)="addLoadcell(loadcell)">Add</button>
                                                <mat-icon *ngIf="loadcellIsSelected(loadcell)" class="text-green-500 icon-size-4 ml-1" svgIcon="feather:check"></mat-icon>
                                                <span *ngIf="loadcellIsSelected(loadcell)" class="text-green-500 text-md">Added</span>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <!-- Assets -->
                                <ng-container *ngIf="getDealType() == DealType.Hire">
                                    <ng-container *ngFor="let asset of filteredAssets; trackBy: trackByFn">
                                        <div class="border rounded-md p-3 flex gap-2 items-center">
                                            <div class="flex-auto">
                                                <div class="flex gap-4 mb-1 items-center">
                                                    <div>{{asset.serialNumber}}</div>
                                                    <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{asset.stock}} in stock</div>
                                                </div>
                                                <div class="text-md">{{asset.name}}</div>
                                            </div>
                                            <div>
                                                <button mat-stroked-button (click)="openAssetOverview(asset)">Overview</button>
                                            </div>
                                            <div class="flex items-center">
                                                <button *ngIf="!assetIsSelected(asset)" mat-flat-button color="primary" (click)="addAsset(asset)">Add</button>
                                                <mat-icon *ngIf="assetIsSelected(asset)" class="text-green-500 icon-size-4 ml-1" svgIcon="feather:check"></mat-icon>
                                                <span *ngIf="assetIsSelected(asset)" class="ml-1 text-green-500 text-md">Added</span>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Chosen Products/Parts - Line Items -->
                        <div class="border rounded-xl bg-white col-span-3 p-4" [class.col-span-5]="isCustomQuote() || getDealType() == DealType.Marine" [class.px-0]="isCustomQuote()">
                            <div *ngIf="!isCustomQuote()" [class.px-4]="isCustomQuote()">Selected {{isCustomQuote() ? 'Parts' : getDealType() == DealType.Calibration ? 'Loadcells' : getDealType() == DealType.Hire ? 'Assets' : getDealType() == DealType.Marine ? 'Items' : 'Products'}}</div>

                            <form *ngIf="productsForm" [formGroup]="productsForm"
                                class="flex flex-col gap-2 py-3"
                                [class.h-[calc(100vh-690px)]]="!isCustomQuote()"
                                [class.overflow-y-scroll]="!isCustomQuote()"
                                >

                                <ng-container *ngIf="getDealType() == DealType.Standard || getDealType() == DealType.RepeatCustom && productItems?.controls" formArrayName="productLines">
                                    <ng-container *ngFor="let itemControl of productItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="border rounded-md p-3 flex gap-2 items-center">
                                            <div class="flex-auto">
                                                <div class="flex gap-4 mb-1 items-center">
                                                    <div>{{lookupProduct(itemControl)?.partNumber}}</div>
                                                    <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{lookupProduct(itemControl)?.freeStock}} in stock</div>
                                                </div>
                                                <div class="text-md">{{lookupProduct(itemControl)?.description}}</div>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                                    <mat-label>Qty</mat-label>
                                                    <input matInput type="number" [formControlName]="'quantity'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                                    <mat-label>Price</mat-label>
                                                    <input matInput [value]="(itemControl.controls['cost'].value ?? 0).toFixed(2)" disabled>
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <!-- <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                                    <mat-label>Discount</mat-label>
                                                    <input matInput type="number" [formControlName]="'discount'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div> -->
                                            <div class="mt-auto">
                                                <button mat-icon-button (click)="deleteProductItem(i)">
                                                    <mat-icon svgIcon="heroicons_outline:x-mark" class="icon-size-5"></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="getDealType() == DealType.Hire && hireItems?.controls" formArrayName="hireLines">
                                    <ng-container *ngFor="let itemControl of hireItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="border rounded-md p-3 flex gap-2 items-center">
                                            <div class="flex-auto">
                                                <div class="flex gap-4 mb-1 items-center">
                                                    <div>{{lookupAsset(itemControl)?.serialNumber}}</div>
                                                    <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{lookupAsset(itemControl)?.stock}} in stock</div>
                                                </div>
                                                <div class="text-md">{{lookupAsset(itemControl)?.name}}</div>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense w-[140px]" subscriptSizing="dynamic">
                                                    <mat-label>Hire From</mat-label>
                                                    <input
                                                        (dateChange)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)"
                                                        [formControlName]="'hireFrom'"
                                                        [matDatepicker]="pickerfrom"
                                                        matInput>
                                                    <mat-datepicker-toggle matIconSuffix [for]="pickerfrom"></mat-datepicker-toggle>
                                                    <mat-datepicker #pickerfrom></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense w-[140px]" subscriptSizing="dynamic">
                                                    <mat-label>Hire To</mat-label>
                                                    <input
                                                        (dateChange)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)"
                                                        [formControlName]="'hireTo'"
                                                        [matDatepicker]="pickerto"
                                                        matInput>
                                                    <mat-datepicker-toggle matIconSuffix [for]="pickerto"></mat-datepicker-toggle>
                                                    <mat-datepicker #pickerto></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                                    <mat-label>Price</mat-label>
                                                    <input matInput [value]="(lookupAsset(itemControl)?.cost ?? 0).toFixed(2)" disabled>
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <div class="mt-auto">
                                                <button mat-icon-button (click)="deleteHireItem(i)">
                                                    <mat-icon svgIcon="heroicons_outline:x-mark" class="icon-size-5"></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="getDealType() == DealType.Calibration && calibrationItems?.controls" formArrayName="calibrationLines">
                                    <ng-container *ngFor="let itemControl of calibrationItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="border rounded-md p-3 flex gap-2 items-center">
                                            <div class="flex-auto">
                                                <div class="flex gap-4 mb-1 items-center">
                                                    <div>{{lookupLoadcell(itemControl)?.bookingRef}}</div>
                                                    <!-- <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{lookupLoadcell(itemControl)?.freeStock}} in stock</div> -->
                                                </div>
                                                <div class="text-md">{{lookupLoadcell(itemControl)?.customerCode}}</div>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense w-[200px]" subscriptSizing="dynamic">
                                                    <mat-label>Description</mat-label>
                                                    <input matInput [formControlName]="'description'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                                    <mat-label>Qty</mat-label>
                                                    <input matInput type="number" [formControlName]="'quantity'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                                    <mat-label>Price</mat-label>
                                                    <input matInput type="number" [formControlName]="'cost'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[150px]" subscriptSizing="dynamic">
                                                    <mat-label>Notes</mat-label>
                                                    <input matInput [formControlName]="'notes'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                </mat-form-field>
                                            </div>
                                            <div class="mt-auto">
                                                <button mat-icon-button (click)="deleteCalibrationItem(i)">
                                                    <mat-icon svgIcon="heroicons_outline:x-mark" class="icon-size-5"></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="getDealType() == DealType.Marine && marineItems?.controls" formArrayName="marineLines">
                                    <ng-container *ngFor="let itemControl of marineItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="border rounded-md p-3 flex gap-2 items-center">
                                            <!-- <div class="flex-auto">
                                                <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
                                                    <mat-label>Part Number</mat-label>
                                                    <input matInput [formControlName]="'partNumber'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                </mat-form-field>
                                            </div> -->
                                            <div class="flex-auto">
                                                <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
                                                    <mat-label>Part Name</mat-label>
                                                    <input
                                                        matInput
                                                        [formControlName]="'partName'"
                                                        [matAutocomplete]="marinePartAuto"
                                                        (input)="filterMarineParts($event)"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">

                                                    <mat-autocomplete #marinePartAuto="matAutocomplete">
                                                        <ng-container *ngFor="let marinePart of filteredMarineParts">
                                                            <mat-option [value]="marinePart.partName" (onSelectionChange)="onMarinePartSelected(marinePart, itemControl)">
                                                                {{ marinePart.partName }}
                                                            </mat-option>
                                                        </ng-container>
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <div class="flex-auto max-w-[220px]">
                                                <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
                                                    <mat-label>Supplier</mat-label>
                                                    <input matInput [formControlName]="'supplier'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                </mat-form-field>
                                            </div>
                                            <div class="flex-auto max-w-[220px]">
                                                <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
                                                    <mat-label>Category</mat-label>
                                                    <input
                                                        matInput
                                                        [formControlName]="'category'"
                                                        [matAutocomplete]="marinePartCatAuto"
                                                        (input)="filterMarinePartCategories($event)"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">

                                                    <mat-autocomplete #marinePartCatAuto="matAutocomplete">
                                                        <ng-container *ngFor="let cat of filteredMarinePartCategories">
                                                            <mat-option [value]="cat" (onSelectionChange)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                                {{ cat }}
                                                            </mat-option>
                                                        </ng-container>
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[120px]" subscriptSizing="dynamic">
                                                    <mat-label>Qty</mat-label>
                                                    <input matInput type="number" [formControlName]="'quantity'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[120px]" subscriptSizing="dynamic">
                                                    <mat-label>Cost</mat-label>
                                                    <input matInput type="number" [formControlName]="'internalCost'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[120px]" subscriptSizing="dynamic">
                                                    <mat-label>Price</mat-label>
                                                    <input matInput type="number" [formControlName]="'cost'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <!-- <div>
                                                <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                                    <mat-label>Discount</mat-label>
                                                    <input matInput type="number" [formControlName]="'discount'"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div> -->
                                            <div class="mt-auto">
                                                <button mat-icon-button (click)="deleteMarineItem(i)">
                                                    <mat-icon svgIcon="heroicons_outline:x-mark" class="icon-size-5"></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <div class="flex justify-end">
                                        <button mat-flat-button color="primary" (click)="addMarineItem()">Add</button>
                                    </div>
                                    
                                </ng-container>

                                <ng-container *ngIf="isCustomQuote() && partItems?.controls" formArrayName="partLines">
                                    <div class="ml-8 text-xl mb-2 -mt-2">Parts</div>

                                    <div class="flex flex-col divide-y">
                                        <div class="grid grid-cols-12 bg-gray-50 border-t py-2 px-6 gap-3 items-center uppercase text-md tracking-tight">
                                            <span>#</span>
                                            <span class="col-span-3">Part Number / Description</span>
                                            <span>Type</span>
                                            <span>Qty</span>
                                            <span>Unit</span>
                                            <span class="col-span-2">Unit Cost</span>
                                            <span>Total Cost</span>
                                            <span>Stock Status</span>
                                            <span class="text-right">Actions</span>
                                        </div>
                                        <ng-container *ngFor="let itemControl of partItems?.controls; let i = index" [formGroupName]="i">
                                            
                                            <div class="grid grid-cols-12 py-2 px-6 gap-3 items-center h-[59px] transition-[height]" [class.row-hidden]="itemControl.controls['hidden'].value">

                                                <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                    <input matInput formControlName="level" (blur)="reorderLevels()" (input)="constrainLevelFormat($event, itemControl)">
                                                </mat-form-field>

                                                <div class="col-span-3 flex gap-2 items-center">
                                                    <span [style]="'padding-left: ' + (getLevelIndent(itemControl) * 1.2) + 'rem;'">
                                                        <mat-icon
                                                            class="icon-size-5"
                                                            [class.cursor-pointer]="hasLevelChildren(itemControl)"
                                                            style="vertical-align: middle;"
                                                            [svgIcon]="!hasLevelChildren(itemControl) ? '' : areLevelChildrenHidden(itemControl) ? 'mat_outline:keyboard_arrow_right' : 'mat_outline:keyboard_arrow_down'"
                                                            (click)="hasLevelChildren(itemControl) && toggleLevelChildrenHide(itemControl)">
                                                        </mat-icon>
                                                    </span>

                                                    <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
                                                        <input matInput formControlName="partId" [matAutocomplete]="partAuto" autocomplete="off" (input)="filterParts($event)" (focus)="setupFilterParts(itemControl)"/>
                                                        <mat-autocomplete
                                                            #partAuto="matAutocomplete"
                                                            [displayWith]="displayPart"
                                                            autoActiveFirstOption
                                                            [requireSelection]="true">
                                                            <ng-container *ngFor="let part of filteredParts">
                                                                <mat-option [value]="part.id" *ngIf="showPartOption(part, itemControl)" (onSelectionChange)="onPartSelected(itemControl, part)">
                                                                    <div class="flex gap-1 items-center">
                                                                        <span>{{part.number}}</span>
                                                                        <mat-icon *ngIf="part.isHighRisk" [matTooltip]="'High Risk'"          color="warn" class="icon-size-4 m-0" svgIcon="mat_solid:warning"></mat-icon>
                                                                        <mat-icon *ngIf="part.isCritical" [matTooltip]="'Critical Component'" color="warn" class="icon-size-4 m-0" svgIcon="mat_solid:flag">
                                                                        <mat-icon *ngIf="part.currentStock < part.minimumStock" [matTooltip]="'Stock under Minimum'" color="warn" class="icon-size-5" svgIcon="mat_solid:remove_shopping_cart"></mat-icon></mat-icon>
                                                                    </div>
                                                                    <div class="text-sm leading-[1.1] pb-2">{{part.description}}</div>
                                                                </mat-option>
                                                            </ng-container>
                                                        </mat-autocomplete>
                                                        <mat-icon matSuffix class="text-[#0000008a] mr-[-0.4rem] cursor-pointer">arrow_drop_down</mat-icon>
                                                    </mat-form-field>
                                                </div>

                                                <span class="rounded-full px-2 w-min text-sm whitespace-pre" [class.bg-gray-50]="!isAssemblyType(itemControl)" [class.bg-blue-100]="isAssemblyType(itemControl)">
                                                    {{getComponentType(itemControl) | uppercase}}
                                                </span>

                                                <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                    <input matInput type="number" step="1" min="1" formControlName="quantity"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                </mat-form-field>

                                                <span>{{PartUnitType[lookupPart(itemControl)?.partUnitType ?? 0]}}</span>

                                                <!-- <span>{{lookupPart(itemControl)?.cost | currency:'GBP'}}</span> -->
                                                <mat-form-field class="col-span-2 fuse-mat-dense w-full" subscriptSizing="dynamic">
                                                    <input matInput formControlName="cost" type="number" step="0.1" min="0"
                                                        (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    <span matPrefix>£</span>
                                                </mat-form-field>


                                                <span>{{getItemSubtotal(itemControl) | currency:'GBP'}}</span>

                                                <div class="flex gap-2 items-center">
                                                    <ng-container *ngIf="lookupPart(itemControl)">
                                                        <div class="h-2 w-2 rounded-full bg-orange-500"></div>
                                                        <span>{{lookupPart(itemControl)?.currentStock}} in stock</span>
                                                    </ng-container>
                                                </div>

                                                <div class="text-right">
                                                    <button *ngIf="false" mat-icon-button [disabled]="!getSubstitutes(itemControl)?.length" [matMenuTriggerFor]="substitutesMenu">
                                                        <mat-icon class="icon-size-4" [svgIcon]="'custom:compare'"></mat-icon>
                                                    </button>
                                                    <mat-menu *ngIf="false"
                                                        class="max-h-72"
                                                        #substitutesMenu="matMenu"
                                                        [xPosition]="'before'">
                                                        <div class="px-4">Switch to Substitute Part:</div>
                                                        <div class="flex flex-col">
                                                            <ng-container *ngFor="let part of getSubstitutes(itemControl)">
                                                                <!-- Divider -->
                                                                <div class="w-full border-b my-1"></div>

                                                                <button mat-menu-item (click)="selectSubstitute(itemControl, part)">
                                                                    <div class="flex flex-col">
                                                                        <div class="flex justify-between gap-2 items-center">
                                                                            <span>{{part.number}}</span>
                                                                            <span *ngIf="isCheapestSubstitute(itemControl, part)" class="text-sm text-green-500">cheapest</span>
                                                                        </div>
                                                                        <div class="text-sm leading-none">{{part.description}}</div>
                                                                        <div class="text-sm">Cost: {{part.cost | currency:'GBP'}}  |  Stock: {{part.currentStock}}</div>
                                                                    </div>
                                                                </button>
                                                            </ng-container>
                                                        </div>
                                                    </mat-menu>


                                                    <button mat-icon-button (click)="deletePartItem(i)">
                                                        <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            
                                            
                                            <!-- <div class="border rounded-md p-3 flex gap-2 items-center">
                                                <div class="flex-auto">
                                                    <div class="flex gap-4 mb-1 items-center">
                                                        <div>{{lookupPart(itemControl)?.number}}</div>
                                                        <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{lookupPart(itemControl)?.currentStock}} in stock</div>
                                                    </div>
                                                    <div class="text-md">{{lookupPart(itemControl)?.description}}</div>
                                                </div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <mat-label>Qty</mat-label>
                                                        <input matInput type="number" [formControlName]="'quantity'">
                                                    </mat-form-field>
                                                </div>
                                                <div class="mt-auto">
                                                    <button mat-icon-button (click)="deletePartItem(i)">
                                                        <mat-icon svgIcon="heroicons_outline:x-mark" class="icon-size-5"></mat-icon>
                                                    </button>
                                                </div>
                                            </div> -->
                                        </ng-container>
                                    </div>
                                    <!-- Add -->
                                    <div
                                        class="col-span-4 -mt-2 text-center justify-center items-center border border-dashed border-2 p-3 hover:border-primary cursor-pointer"
                                        (click)="addPartItem()">
                                        + Click to add another component
                                    </div>
                                </ng-container>

                                <!-- Empty -->
                                <div *ngIf="
                                    ((getDealType() == DealType.Standard || getDealType() == DealType.RepeatCustom) && !productItems?.controls.length) ||
                                    (isCustomQuote() && !partItems?.controls.length) ||
                                    (getDealType() == DealType.Calibration && !calibrationItems?.controls.length) ||
                                    (getDealType() == DealType.Hire && !hireItems?.controls.length) ||
                                    (getDealType() == DealType.Marine && !marineItems?.controls.length)
                                    "
                                    
                                    class="my-4 italic text-center text-hint">
                                    No {{isCustomQuote() ? 'parts' : getDealType() == DealType.Calibration ? 'loadcells' : getDealType() == DealType.Hire ? 'assets' : getDealType() == DealType.Marine ? 'items' : 'products'}} added yet.
                                </div>

                                <ng-container *ngIf="isCustomQuote()">
                                    <div class="grid grid-cols-4 gap-x-8 gap-y-4 w-full relative px-8">

                                        <!-- Divider -->
                                        <div class="col-span-4 mt-2 border-t -mx-8"></div>

                                        <!-- Assembly proccess -->
                                        <h3 class="col-span-4 text-xl">Assembly Process</h3>
                                        <div class="col-span-4 flex flex-col divide-y -mx-8">
                                            <!-- Header -->
                                            <div class="grid grid-cols-12 bg-gray-50 border-t py-2 gap-3 items-center uppercase text-md tracking-tight" style="padding-left: 3rem; padding-right: 1.5rem;">
                                                <span>Seq</span>
                                                <span>Op Code</span>
                                                <span class="col-span-2">Operation Name</span>
                                                <span class="col-span-2">Cost Centre</span>
                                                <span>Setup (hr)</span>
                                                <span>Run (hr)</span>
                                                <span class="col-span-2">Notes</span>
                                                <span class="col-span-2 text-right">Actions</span>
                                            </div>
                                            <!-- Rows with Drag & Drop -->
                                            <div cdkDropList
                                                [cdkDropListData]="bomAssemblyProcesses"
                                                (cdkDropListDropped)="onProcessDrop($event)">
                                                <ng-container *ngIf="bomAssemblyProcesses?.length">
                                                    <ng-container *ngFor="let process of bomAssemblyProcesses; let i = index">
                                                        <div class="grid grid-cols-12 py-2 gap-3 items-center group relative"
                                                            cdkDrag
                                                            style="padding-left: 3rem; padding-right: 1.5rem;">

                                                            <!-- Drag Handle -->
                                                            <div cdkDragHandle
                                                                class="absolute left-2 top-1/2 transform -translate-y-1/2 w-6 h-6 bg-gray-500 rounded cursor-move opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                                                <mat-icon [svgIcon]="'heroicons_outline:bars-3'" class="icon-size-4 text-white"></mat-icon>
                                                            </div>

                                                            <span>{{process.sequence}}</span>

                                                            <span>{{process.operationCode}}</span>

                                                            <div class="col-span-2">
                                                                <div>{{process.operationName}}</div>
                                                                <div *ngIf="process.isSubcontracted" class="text-xs text-orange-500 flex items-center gap-1">
                                                                    <mat-icon class="icon-size-3">business</mat-icon>
                                                                    {{process.subcontractorName}}
                                                                </div>
                                                            </div>

                                                            <span class="col-span-2">{{getCostCentreName(process.costCentreCode)}}</span>

                                                            <span>{{process.setupHours * (process.isSubcontracted ? 35 : 1)}}</span>

                                                            <span>{{process.runPerUnitHours}}</span>

                                                            <span class="col-span-2 text-sm text-secondary">{{process.notes || '-'}}</span>

                                                            <div class="col-span-2 text-right">
                                                                <button mat-icon-button (click)="openAssemblyProcessPopup(process, false)">
                                                                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                                                                </button>
                                                                <button mat-icon-button (click)="deleteAssemblyProcess(i)">
                                                                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </div>
                                        <!-- Add -->
                                        <div
                                            class="col-span-4 -mt-4 -mx-8 text-center justify-center items-center border border-dashed border-2 p-3 hover:border-primary cursor-pointer"
                                            (click)="openAssemblyProcessPopup({}, true)">
                                            + Click to add process step
                                        </div>


                                        <!-- Divider -->
                                        <div class="col-span-4 mt-2 border-t -mx-8"></div>

                                        <h3 class="col-span-4 text-xl">Labour Quote</h3>
                                        
                                        <!-- Divider -->
                                        <div class="col-span-4 mb-2 border-t -mx-8"></div>

                                        
                                        <!-- Engineers -->
                                        <div class="col-span-2">
                                            <h4 class="text-lg mb-3">Cost Centre</h4>

                                            <div class="w-full flex flex-col rounded-xl border overflow-hidden">
                                                <!-- Header -->
                                                <div class="grid grid-cols-6 bg-gray-50 py-2 px-6 gap-2 items-center uppercase text-md tracking-tight">
                                                    <span class="col-span-2">Cost Centre</span>
                                                    <span>Hours</span>
                                                    <span>Rate</span>
                                                    <span>Total</span>
                                                    <span class="text-right">Actions</span>
                                                </div>

                                                <!-- Assembly Process Cost Centers (non-subcontracted) -->
                                                <ng-container *ngIf="getCostCentreProcesses()?.length">
                                                    <ng-container *ngFor="let process of getCostCentreProcesses(); let i = index">
                                                        <div class="grid grid-cols-6 py-2 px-6 gap-2 items-center border-t">
                                                            <span class="col-span-2">{{getCostCentreName(process.costCentreCode)}}</span>
                                                            <span>{{(process.setupHours || 0) * (process.isSubcontracted ? 35 : 1) + (process.runPerUnitHours || 0)}}</span>
                                                            <span>{{process.costCentreRate | currency:'GBP'}}</span>
                                                            <span>{{getProcessTotal(process) | currency:'GBP'}}</span>
                                                            <div class="text-right">
                                                                <button mat-icon-button (click)="deleteAssemblyProcess(getCostCentreProcessIndex(process))">
                                                                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </div>

                                            <div class="text-lg text-right mt-2">Subtotal: {{getCostCentreProcessesTotal() | currency:'GBP'}}</div>
                                        </div>

                                        <!-- Contractors -->
                                        <div class="col-span-2">
                                            <h4 class="text-lg mb-3">Subcontractors</h4>

                                            <div class="w-full flex flex-col rounded-xl border overflow-hidden">
                                                <!-- Header -->
                                                <div class="grid grid-cols-6 bg-gray-50 py-2 px-6 gap-2 items-center uppercase text-md tracking-tight">
                                                    <span class="col-span-2">Contractor</span>
                                                    <span>Qty</span>
                                                    <span>Rate</span>
                                                    <span>Total</span>
                                                    <span class="text-right">Actions</span>
                                                </div>

                                                <!-- Assembly Process Subcontractors -->
                                                <ng-container *ngIf="getSubcontractorProcesses()?.length">
                                                    <ng-container *ngFor="let process of getSubcontractorProcesses(); let i = index">
                                                        <div class="grid grid-cols-6 py-2 px-6 gap-2 items-center border-t">
                                                            <span class="col-span-2">{{process.subcontractorName}}</span>
                                                            <span>{{(process.setupHours || 0) * (process.isSubcontracted ? 35 : 1) + (process.runPerUnitHours || 0)}}</span>
                                                            <span>{{process.subcontractorHourlyRate | currency:'GBP'}}</span>
                                                            <span>{{getSubcontractorProcessTotal(process) | currency:'GBP'}}</span>
                                                            <div class="text-right">
                                                                <button mat-icon-button (click)="deleteAssemblyProcess(getSubcontractorProcessIndex(process))">
                                                                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </div>

                                            <div class="text-lg text-right mt-2">Subtotal: {{getAssemblySubcontractorTotal() | currency:'GBP'}}</div>
                                        </div>

                                        <!-- Divider -->
                                        <div class="col-span-4 my-4 border-t -mx-8"></div>

                                        <!-- Actions/Totals -->
                                        <div class="col-span-4 flex items-center justify-end">
                                            <div class="flex gap-12">
                                                <div>
                                                    <div class="text-sm">Materials</div>
                                                    <div class="text-xl">{{getMaterialTotal() | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="text-sm">Labour</div>
                                                    <div class="text-xl">{{getCostCentreProcessesTotal() + getAssemblySubcontractorTotal() | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="text-sm">Consumables (5%)</div>
                                                    <div class="text-xl">{{getGrandTotal() * 0.05 | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="text-sm">Total Cost</div>
                                                    <div class="text-xl text-primary">{{getGrandTotal() * 1.05 | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- Attachments -->
                                    <div class="px-7 pt-4">
                                        <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
                                            <div class="text-xl">BOM Attachments</div>
                                            <div class="w-full flex flex-row flex-0 overflow-x-auto overflow-y-hidden" style="height:102px;">                
                                                <div> <!--class="-ml-2"-->
                                                    <!-- Upload file -->
                                                    <button mat-icon-button
                                                    (click)="openFileUpload(true)">
                                                        <mat-icon
                                                            class="icon-size-5"
                                                            [svgIcon]="'heroicons_solid:paper-clip'"></mat-icon>
                                                    </button>
                                                </div>

                                                <!-- Files -->
                                                <ng-container *ngIf="fileInfos?.length > 0">
                                                    <ng-container *ngFor="let file of fileInfos">
                                                        <div *ngIf="file.isBom" class="file-container p-2 mx-1">
                                                            <!-- Icons -->
                                                            <div [class.cursor-pointer]="dealId" class="relative text-center" (click)="dealId && download(file)">
                                                                <div class="inline-block relative text-center">
                                                                    <mat-icon
                                                                        class="icon-size-14 text-hint opacity-50"
                                                                        [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                                                    <div
                                                                        class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                                                                        [class.bg-red-600]="file.type == '.pdf'"
                                                                        [class.bg-blue-600]="file.type == '.doc'"
                                                                        [class.bg-green-600]="file.type == '.xls'"
                                                                        [class.bg-gray-600]="file.type == '.txt'"
                                                                        [class.bg-amber-600]="file.type == '.jpg'"
                                                                        [class.bg-yellow-500]="file.type == '.png'">
                                                                        {{file.type.toUpperCase()}}
                                                                    </div>
                                                                    <button *ngIf="!isBasic" class="absolute" (click)="deleteFile(file, $event)">
                                                                        <mat-icon class="icon-size-2 text-red-600">close</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div [class.cursor-pointer]="dealId" class="file-name text-s text-center mt-1" (click)="dealId && download(file)">{{file.name}}</div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </form>
                        </div>
                    </div>

                    
                    <div class="flex justify-between gap-2">
                        <button
                            mat-stroked-button
                            matStepperPrevious
                            type="button">
                            Back
                        </button>
                        <button
                            *ngIf="isCustomQuote()"
                            class="ml-auto"
                            (click)="sendToSales()"
                            mat-flat-button
                            type="button"
                            [color]="'primary'"
                            [disabled]="!productsForm?.valid">
                            Send to Sales
                        </button>
                        <button
                            *ngIf="!isCustomQuote() || deal?.isSentToSales"
                            mat-flat-button
                            matStepperNext
                            type="button"
                            [color]="'primary'"
                            [disabled]="!productsForm?.valid">
                            Next
                        </button>
                    </div>
                </div>
            </mat-step>
            
            <!-- Review Step -->
            <mat-step label="Review Summary" [stepControl]="summaryForm">
                <div class="w-full flex flex-col gap-4">

                    <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8] mt-4">
                        <div class="text-xl">Selected Items</div>

                        <!-- Line Items -->
                        <form *ngIf="productsForm" [formGroup]="productsForm" class="flex flex-col gap-4">

                            <ng-container *ngIf="(getDealType() == DealType.Standard || getDealType() == DealType.RepeatCustom) && productItems?.controls" formArrayName="productLines">
                                <ng-container *ngFor="let itemControl of productItems?.controls; let i = index" [formGroupName]="i">
                                    <div class="border rounded-xl bg-white flex flex-col gap-4">
                                        <div class="py-4 px-6 border-b flex gap-4 items-center">
                                            <div>Line: {{i+1}}</div>
                                            <div>Product ID: {{lookupProduct(itemControl)?.partNumber}}</div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">{{lookupProduct(itemControl)?.description}}</div>
                                            <div class="ml-auto text-primary text-xl">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                        </div>

                                        <div class="text-lg px-6">Specification:</div>
                                        <ul class="px-6 list-disc list-outside ml-6 flex flex-col gap-2">
                                            <li>Quotation for {{lookupProduct(itemControl)?.description}}</li>
                                            <li>Product Code: {{lookupProduct(itemControl)?.partNumber}}</li>
                                            <li>Manufactured to industrial standards</li>
                                            <li>Quality controlled and tested prior to dispatch</li>
                                            <li>Full technical documentation included</li>
                                            <li>Supplied with material certificates and test reports</li>
                                        </ul>

                                        <div class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md">
                                            <div>
                                                <div class="text-lg mb-1">Quantity</div>
                                                <div>{{itemControl.controls['quantity'].value}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">U/M</div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Unit Price</div>
                                                <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Discount</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput type="number" [formControlName]="'discount'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                        <span matPrefix>£</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Discount %</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput type="number" [value]="getDiscountPercentage(itemControl)"
                                                            (change)="updateDiscountFromPercentage($event, itemControl)">
                                                        <span matSuffix>%</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Lead Time</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput [formControlName]="'leadTime'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Lead Time Type</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <mat-select [formControlName]="'leadTimeType'"
                                                            (selectionChange)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                            <mat-option *ngFor="let option of leadTimeTypes" [value]="option.value">{{option.name}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Total Price</div>
                                                <div class="text-primary text-lg">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            
                            <ng-container *ngIf="getDealType() == DealType.Hire && hireItems?.controls" formArrayName="hireLines">
                                <ng-container *ngFor="let itemControl of hireItems?.controls; let i = index" [formGroupName]="i">
                                    <div class="border rounded-xl bg-white flex flex-col gap-4">
                                        <div class="py-4 px-6 border-b flex gap-4 items-center">
                                            <div>Line: {{i+1}}</div>
                                            <div>Asset ID: {{lookupAsset(itemControl)?.serialNumber}}</div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">{{lookupAsset(itemControl)?.name}}</div>
                                            <div class="ml-auto text-primary text-xl">{{itemControl.controls['cost'].value * getHireQuantity(itemControl) - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                        </div>

                                        <div class="text-lg px-6">Specification:</div>
                                        <ul class="px-6 list-disc list-outside ml-6 flex flex-col gap-2">
                                            <li>Quotation for {{lookupAsset(itemControl)?.name}}</li>
                                            <li>Product Code: {{lookupAsset(itemControl)?.serialNumber}}</li>
                                            <li>Manufactured to industrial standards</li>
                                            <li>Quality controlled and tested prior to dispatch</li>
                                            <li>Full technical documentation included</li>
                                            <li>Supplied with material certificates and test reports</li>
                                        </ul>

                                        <div class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md">
                                            <div>
                                                <div class="text-lg mb-1">Quantity</div>
                                                <div>{{getHireQuantity(itemControl)}} days</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">U/M</div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Unit Price</div>
                                                <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Discount</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput type="number" [formControlName]="'discount'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                        <span matPrefix>£</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Discount %</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput type="number" [value]="getDiscountPercentage(itemControl, true)"
                                                            (change)="updateDiscountFromPercentage($event, itemControl, true)">
                                                        <span matSuffix>%</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Lead Time</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput [formControlName]="'leadTime'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Lead Time Type</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <mat-select [formControlName]="'leadTimeType'"
                                                            (selectionChange)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                            <mat-option *ngFor="let option of leadTimeTypes" [value]="option.value">{{option.name}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Total Price</div>
                                                <div class="text-primary text-lg">{{itemControl.controls['cost'].value * getHireQuantity(itemControl) - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="getDealType() == DealType.Calibration && calibrationItems?.controls" formArrayName="calibrationLines">
                                <ng-container *ngFor="let itemControl of calibrationItems?.controls; let i = index" [formGroupName]="i">
                                    <div class="border rounded-xl bg-white flex flex-col gap-4">
                                        <div class="py-4 px-6 border-b flex gap-4 items-center">
                                            <div>Line: {{i+1}}</div>
                                            <div>Loadcell ID: {{lookupLoadcell(itemControl)?.bookingRef}}</div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">{{lookupLoadcell(itemControl)?.customerCode}}</div>
                                            <div class="ml-auto text-primary text-xl">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                        </div>

                                        <div class="text-lg px-6">Specification:</div>
                                        <ul class="px-6 list-disc list-outside ml-6 flex flex-col gap-2">
                                            <li>Quotation for {{itemControl.controls['description'].value}}</li>
                                            <li>Product Code: {{lookupLoadcell(itemControl)?.serialNumber}}</li>
                                            <li>Calibrated to industrial standards</li>
                                            <!-- <li>Quality controlled and tested prior to dispatch</li>
                                            <li>Full technical documentation included</li>
                                            <li>Supplied with material certificates and test reports</li> -->
                                        </ul>

                                        <div class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md">
                                            <div>
                                                <div class="text-lg mb-1">Quantity</div>
                                                <div>{{itemControl.controls['quantity'].value}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">U/M</div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Unit Price</div>
                                                <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Discount</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput type="number" [formControlName]="'discount'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                        <span matPrefix>£</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Discount %</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput type="number" [value]="getDiscountPercentage(itemControl)"
                                                            (change)="updateDiscountFromPercentage($event, itemControl)">
                                                        <span matSuffix>%</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Lead Time</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput [formControlName]="'leadTime'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Lead Time Type</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <mat-select [formControlName]="'leadTimeType'"
                                                            (selectionChange)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                            <mat-option *ngFor="let option of leadTimeTypes" [value]="option.value">{{option.name}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Total Price</div>
                                                <div class="text-primary text-lg">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>


                            <ng-container *ngIf="getDealType() == DealType.Marine && marineItems?.controls" formArrayName="marineLines">
                                <ng-container *ngFor="let itemControl of marineItems?.controls; let i = index" [formGroupName]="i">
                                    <div class="border rounded-xl bg-white flex flex-col gap-4">
                                        <div class="py-4 px-6 border-b flex gap-4 items-center">
                                            <div>Line: {{i+1}}</div>
                                            <div>Part: {{itemControl.controls['partName'].value}}</div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">{{itemControl.controls['supplier'].value}}</div>
                                            <div class="ml-auto text-primary text-xl">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                        </div>

                                        <div class="text-lg px-6">Specification:</div>
                                        <ul class="px-6 list-disc list-outside ml-6 flex flex-col gap-2">
                                            <li>Quotation for {{itemControl.controls['partName'].value}}</li>
                                            <!-- <li>Product Code: {{itemControl.controls['partNumber'].value}}</li> -->
                                            <li>Manufactured to industrial standards</li>
                                            <li>Quality controlled and tested prior to dispatch</li>
                                            <li>Full technical documentation included</li>
                                            <li>Supplied with material certificates and test reports</li>
                                        </ul>

                                        <div class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md">
                                            <div>
                                                <div class="text-lg mb-1">Quantity</div>
                                                <div>{{itemControl.controls['quantity'].value}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">U/M</div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Unit Price</div>
                                                <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Discount</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput type="number" [formControlName]="'discount'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                        <span matPrefix>£</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Discount %</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput type="number" [value]="getDiscountPercentage(itemControl)"
                                                            (change)="updateDiscountFromPercentage($event, itemControl)">
                                                        <span matSuffix>%</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Lead Time</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput [formControlName]="'leadTime'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Lead Time Type</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <mat-select [formControlName]="'leadTimeType'"
                                                            (selectionChange)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                            <mat-option *ngFor="let option of leadTimeTypes" [value]="option.value">{{option.name}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Total Price</div>
                                                <div class="text-primary text-lg">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="isCustomQuote() && partItems?.controls" formArrayName="partLines">

                                <!-- show as one product line -->
                                <div class="border rounded-xl bg-white flex flex-col gap-4">
                                    <div class="py-4 px-6 border-b flex gap-4 items-center">
                                        <div>Line: 1</div>
                                        <div>Product ID: {{customProductPartNumber}}</div>
                                        <div>Rev: 1</div>
                                        <!-- <div class="text-md">{{lookupPart(itemControl)?.description}}</div> -->
                                        <div class="ml-auto text-primary text-xl">{{getTotalPrice() | currency:'GBP'}}</div>
                                    </div>

                                    <div class="text-lg px-6">Specification:</div>
                                    <ul class="px-6 list-disc list-outside ml-6 flex flex-col gap-2">
                                        <li>Quotation for {{customProductName}}</li>
                                        <li>Product Code: {{customProductPartNumber}}</li>
                                        <li>Manufactured to industrial standards</li>
                                        <li>Quality controlled and tested prior to dispatch</li>
                                        <li>Full technical documentation included</li>
                                        <li>Supplied with material certificates and test reports</li>
                                    </ul>

                                    <div class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md">
                                        <div>
                                            <div class="text-lg mb-1">Quantity</div>
                                            <div>1</div>
                                        </div>
                                        <div>
                                            <div class="text-lg mb-1">U/M</div>
                                            <div>EA</div>
                                        </div>
                                        <div>
                                            <div class="text-lg mb-1">Unit Price</div>
                                            <div>{{getTotalPrice() | currency:'GBP'}}</div>
                                        </div>
                                        <ng-container *ngFor="let itemControl of partItems?.controls; let i = index; let first = first;" [formGroupName]="i">
                                            <div *ngIf="first">
                                                <div class="text-lg">Lead Time</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput [formControlName]="'leadTime'"
                                                            (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div *ngIf="first">
                                                <div class="text-lg">Lead Time Type</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <mat-select [formControlName]="'leadTimeType'"
                                                            (selectionChange)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                            <mat-option *ngFor="let option of leadTimeTypes" [value]="option.value">{{option.name}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <div>
                                            <div class="text-lg mb-1">Total Price</div>
                                            <div class="text-primary text-lg">{{getTotalPrice() | currency:'GBP'}}</div>
                                        </div>
                                    </div>
                                </div>


                                <!-- <ng-container *ngFor="let itemControl of partItems?.controls; let i = index" [formGroupName]="i">
                                    <div class="border rounded-xl bg-white flex flex-col gap-4">
                                        <div class="py-4 px-6 border-b flex gap-4 items-center">
                                            <div>Line: {{i+1}}</div>
                                            <div>Part ID: {{lookupPart(itemControl)?.number}}</div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">{{lookupPart(itemControl)?.description}}</div>
                                            <div class="ml-auto text-primary text-xl">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value | currency:'GBP'}}</div>
                                        </div>

                                        <div class="text-lg px-6">Specification:</div>
                                        <ul class="px-6 list-disc list-outside ml-6 flex flex-col gap-2">
                                            <li>Quotation for {{lookupPart(itemControl)?.description}}</li>
                                            <li>Product Code: {{lookupPart(itemControl)?.number}}</li>
                                            <li>Manufactured to industrial standards</li>
                                            <li>Quality controlled and tested prior to dispatch</li>
                                            <li>Full technical documentation included</li>
                                            <li>Supplied with material certificates and test reports</li>
                                        </ul>

                                        <div class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md">
                                            <div>
                                                <div class="text-lg mb-1">Quantity</div>
                                                <div>{{itemControl.controls['quantity'].value}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">U/M</div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Unit Price</div>
                                                <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                            </div>
                                            <div>
                                                <div class="text-lg">Lead Time</div>
                                                <div>
                                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                        <input matInput [formControlName]="'leadTime'">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">Total Price</div>
                                                <div class="text-primary text-lg">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value | currency:'GBP'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container> -->
                            </ng-container>

                        </form>

                        <!-- Margins, Shipping and Totals -->
                        <form *ngIf="summaryForm" [formGroup]="summaryForm" class="flex flex-col gap-4">

                            <!-- Margins -->
                            <div *ngIf="getDealType() != DealType.Standard" class="border rounded-xl bg-white gap-4 py-4 px-6 grid grid-cols-2">
                                <div class="col-span-2 text-xl">Pricing & Margin</div>

                                <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Margin Type</mat-label>
                                    <mat-select [formControlName]="'marginType'" (selectionChange)="onMarginTypeChanged($event)">
                                        <mat-option *ngFor="let option of marginTypes" [value]="option.value">{{option.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <ng-container *ngIf="!!summaryForm?.controls['marginType'].value">
                                    <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                        <mat-label>Margin %</mat-label>
                                        <input matInput type="number" [formControlName]="'margin'" min="15"
                                            (change)="summaryForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                        <span matSuffix>%</span>
                                    </mat-form-field>

                                    <div class="col-span-2 p-4 border rounded-lg grid grid-cols-3" style="background: rgb(240, 249, 255); border-color: rgb(191, 219, 254);">
                                        <div>
                                            <div class="text-lg mb-2">Total Cost</div>
                                            <div class="text-lg">{{getTotalPrice() | currency:'GBP'}}</div>
                                        </div>
                                        <div>
                                            <div class="text-lg mb-2">Margin Amount</div>
                                            <div class="text-lg">{{getTotalPrice() * summaryForm.controls['margin'].value / 100 | currency:'GBP'}}</div>
                                        </div>
                                        <div>
                                            <div class="text-lg mb-2">Selling Price</div>
                                            <div class="text-lg">{{getTotalPrice() * getMarginModifier() | currency:'GBP'}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <!-- Freight/Shipping -->
                            <div class="border rounded-xl bg-white gap-4 py-4 px-6 grid grid-cols-2">
                                <div class="col-span-2 text-xl">Freight & Shipping Details</div>

                                <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Incoterms</mat-label>
                                    <mat-select [formControlName]="'incoterm'"
                                        (selectionChange)="summaryForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                        <mat-option *ngFor="let option of incoterms" [value]="option.value">{{option.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Freight Service</mat-label>
                                    <mat-select [formControlName]="'freightTerm'"
                                        (selectionChange)="summaryForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                        <mat-option *ngFor="let option of freightTerms" [value]="option.value">{{option.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Transport Mode</mat-label>
                                    <mat-select [formControlName]="'transportMode'"
                                        (selectionChange)="summaryForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                        <mat-option *ngFor="let option of transportModes" [value]="option.value">{{option.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>Freight Cost</mat-label>
                                    <input matInput type="number" [formControlName]="'freightCost'"
                                        (change)="summaryForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                    <span matPrefix>£</span>
                                </mat-form-field>
                                

                                <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                    <mat-label>VAT Rate</mat-label>
                                    <mat-select [formControlName]="'vatRate'"
                                        (selectionChange)="summaryForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                        <mat-option *ngFor="let option of vatRates" [value]="option.value">{{option.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <!-- <div class="col-span-2 border rounded-lg p-5" style="background: #fffbeb !important; border-color: #fcd34d;">
                                    <div class="flex items-start gap-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="info" style="width: 16px; height: 16px; color: #f59e0b; flex-shrink: 0; margin-top: 2px;" class="lucide lucide-info"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>
                                        <div class="text-[#92400e]" style="line-height: 1.5;">
                                            <strong>Important:</strong> Rates exclude Customs Clearance, US bond, and Duty. Transit time is approximately 30 days from successful sailing date. Transit times are subject to space availability and pending no delays.
                                        </div>
                                    </div>
                                </div> -->
                            </div>

                            <!-- Totals -->
                            <div class="border border-primary border-2 rounded-xl bg-white divide-y py-4 px-6 flex flex-col">
                                <div class="flex justify-between py-4 text-lg">
                                    <div>Subtotal:</div>
                                    <div>{{getTotalPrice() * getMarginModifier() | currency:'GBP'}}</div>
                                </div>
                                <div class="flex justify-between py-4 text-lg">
                                    <div>Freight:</div>
                                    <div>{{summaryForm.controls['freightCost'].value | currency:'GBP'}}</div>
                                </div>
                                <div class="flex justify-between py-4 text-lg">
                                    <div>VAT ({{summaryForm.controls['vatRate'].value * 100}}%):</div>
                                    <div>{{getTotalPrice() * getMarginModifier() * summaryForm.controls['vatRate'].value | currency:'GBP'}}</div>
                                </div>
                                <div class="flex justify-between py-4 text-2xl">
                                    <div>Total (inc VAT):</div>
                                    <div class="text-primary">
                                        {{ getTotalPrice() * getMarginModifier() * (1 + summaryForm.controls['vatRate'].value) + summaryForm.controls['freightCost'].value | currency:'GBP' }}
                                    </div>
                                </div>
                            </div>

                        </form>

                    </div>

                    <div class="flex justify-between gap-4">
                        <button
                            mat-stroked-button
                            matStepperPrevious
                            type="button">
                            Back
                        </button>
                        <button
                            *ngIf="!dealId || deal?.isWizardInProgress"
                            class="ml-auto"
                            (click)="save(true, true)"
                            mat-stroked-button
                            type="button"
                            [disabled]="!summaryForm?.valid">
                            Save Progress
                        </button>
                        <button
                            mat-flat-button
                            matStepperNext
                            type="button"
                            [color]="'primary'"
                            [disabled]="!summaryForm?.valid">
                            Next
                        </button>
                    </div>
                </div>
            </mat-step>
            
            <!-- PDF Step -->
            <mat-step label="Preview & Send">
                <div class="w-full flex flex-col gap-4 mt-4 pr-2">

                    <div class="flex flex-col p-6 mb-6 border gap-8" id="print-section">

                        <div class="w-full">
                            <header><img src="assets/dlm-images/dlm/dlm-header.png" /></header>

                            <div class="flex flex-col items-center gap-2 py-4 w-full border-b">
                                <div style="font-size: 22px !important;">QUOTATION</div>
                                <div class="text-lg">Reference: {{deal?.quoteNumber || deal?.quoteRef || ''}}</div>
                            </div>
                        </div>

                        <div class="grid grid-cols-2 mx-4">
                            <div class="flex flex-col gap-2">
                                <div class="uppercase">Customer Details</div>
                                <div class="text-xl">{{selectedCompanyName}}</div>
                                <div>
                                    {{getContactEmail()}}
                                    <br/>
                                    {{getContactPhoneNumber()}}
                                </div>
                                <div>{{getCompany()?.address}}</div>
                            </div>
                            <div class="flex flex-col gap-2">
                                <div class="uppercase">Quote Details</div>
                                <div>Title: {{customerForm?.controls['name'].value}}</div>
                                <div>Contact: {{getContactName()}}</div>
                                <div>Date: {{getTodaysDate() | date:'d MMM yyyy'}}</div>
                            </div>
                        </div>

                        <div class="uppercase mx-4">Items</div>

                        <div class="border mx-4 -mt-4">
                            <form *ngIf="productsForm" [formGroup]="productsForm" class="flex flex-col divide-y">
                                <ng-container *ngIf="(getDealType() == DealType.Standard || getDealType() == DealType.RepeatCustom) && productItems?.controls" formArrayName="productLines">
                                    <ng-container *ngFor="let itemControl of productItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div class="border-b flex gap-4 items-center pb-3">
                                                <div>Line: {{i+1}}</div>
                                                <div>Product ID: {{lookupProduct(itemControl)?.partNumber}}</div>
                                                <div>Rev: 1</div>
                                            </div>

                                            <div class="text-lg">{{lookupProduct(itemControl)?.description}}</div>

                                            <div>Specification:</div>
                                            <ul class="-mt-2 list-disc list-outside ml-6 flex flex-col">
                                                <li>Quotation for {{lookupProduct(itemControl)?.description}}</li>
                                                <li>Product Code: {{lookupProduct(itemControl)?.partNumber}}</li>
                                                <li>Manufactured to industrial standards</li>
                                                <li>Quality controlled and tested prior to dispatch</li>
                                                <li>Full technical documentation included</li>
                                                <li>Supplied with material certificates and test reports</li>
                                            </ul>

                                            <div class="flex gap-8 px-6 py-3 bg-gray-50 mt-1">
                                                <div>
                                                    <div class="mb-1">Quantity</div>
                                                    <div>{{itemControl.controls['quantity'].value}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Unit Price</div>
                                                    <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Discount</div>
                                                    <div>{{itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Lead Time</div>
                                                    <div>{{itemControl.controls['leadTime'].value}} {{getLeadTimeTypeName(itemControl.controls['leadTimeType'].value) | lowercase}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Total Price</div>
                                                    <div class="text-primary">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                
                                <ng-container *ngIf="getDealType() == DealType.Hire && hireItems?.controls" formArrayName="hireLines">
                                    <ng-container *ngFor="let itemControl of hireItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div class="border-b flex gap-4 items-center pb-3">
                                                <div>Line: {{i+1}}</div>
                                                <div>Asset ID: {{lookupAsset(itemControl)?.serialNumber}}</div>
                                                <div>Rev: 1</div>
                                            </div>

                                            <div class="text-lg">{{lookupAsset(itemControl)?.name}}</div>

                                            <div>Specification:</div>
                                            <ul class="-mt-2 list-disc list-outside ml-6 flex flex-col">
                                                <li>Quotation for {{lookupAsset(itemControl)?.name}}</li>
                                                <li>Product Code: {{lookupAsset(itemControl)?.serialNumber}}</li>
                                                <li>Manufactured to industrial standards</li>
                                                <li>Quality controlled and tested prior to dispatch</li>
                                                <li>Full technical documentation included</li>
                                                <li>Supplied with material certificates and test reports</li>
                                            </ul>

                                            <div class="flex gap-8 px-6 py-3 bg-gray-50 mt-1">
                                                <div>
                                                    <div class="mb-1">Quantity</div>
                                                    <div>{{getHireQuantity(itemControl)}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Unit Price</div>
                                                    <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Discount</div>
                                                    <div>{{itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Lead Time</div>
                                                    <div>{{itemControl.controls['leadTime'].value}} {{getLeadTimeTypeName(itemControl.controls['leadTimeType'].value) | lowercase}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Total Price</div>
                                                    <div class="text-primary">{{itemControl.controls['cost'].value * getHireQuantity(itemControl) - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="getDealType() == DealType.Calibration && calibrationItems?.controls" formArrayName="calibrationLines">
                                    <ng-container *ngFor="let itemControl of calibrationItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div class="border-b flex gap-4 items-center pb-3">
                                                <div>Line: {{i+1}}</div>
                                                <div>Loadcell ID: {{lookupLoadcell(itemControl)?.bookingRef}}</div>
                                                <div>Rev: 1</div>
                                            </div>

                                            <div class="text-lg">{{lookupLoadcell(itemControl)?.customerCode}}</div>

                                            <div>Specification:</div>
                                            <ul class="-mt-2 list-disc list-outside ml-6 flex flex-col">
                                                <li>Quotation for {{itemControl.controls['description'].value}}</li>
                                                <li>Product Code: {{lookupLoadcell(itemControl)?.serialNumber}}</li>
                                                <li>Calibrated to industrial standards</li>
                                                <!-- <li>Quality controlled and tested prior to dispatch</li>
                                                <li>Full technical documentation included</li>
                                                <li>Supplied with material certificates and test reports</li> -->
                                            </ul>

                                            <div class="flex gap-8 px-6 py-3 bg-gray-50 mt-1">
                                                <div>
                                                    <div class="mb-1">Quantity</div>
                                                    <div>{{itemControl.controls['quantity'].value}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Unit Price</div>
                                                    <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Discount</div>
                                                    <div>{{itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Lead Time</div>
                                                    <div>{{itemControl.controls['leadTime'].value}} {{getLeadTimeTypeName(itemControl.controls['leadTimeType'].value) | lowercase}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Total Price</div>
                                                    <div class="text-primary">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="getDealType() == DealType.Marine && marineItems?.controls" formArrayName="marineLines">
                                    <ng-container *ngFor="let itemControl of marineItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div class="border-b flex gap-4 items-center pb-3">
                                                <div>Line: {{i+1}}</div>
                                                <div>Part: {{itemControl.controls['partName'].value}}</div>
                                                <div>Rev: 1</div>
                                            </div>

                                            <div class="text-lg">{{itemControl.controls['supplier'].value}}</div>

                                            <div>Specification:</div>
                                            <ul class="-mt-2 list-disc list-outside ml-6 flex flex-col">
                                                <li>Quotation for {{itemControl.controls['partName'].value}}</li>
                                                <!-- <li>Product Code: {{itemControl.controls['partNumber'].value}}</li> -->
                                                <li>Manufactured to industrial standards</li>
                                                <li>Quality controlled and tested prior to dispatch</li>
                                                <li>Full technical documentation included</li>
                                                <li>Supplied with material certificates and test reports</li>
                                            </ul>

                                            <div class="flex gap-8 px-6 py-3 bg-gray-50 mt-1">
                                                <div>
                                                    <div class="mb-1">Quantity</div>
                                                    <div>{{itemControl.controls['quantity'].value}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Unit Price</div>
                                                    <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Discount</div>
                                                    <div>{{itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Lead Time</div>
                                                    <div>{{itemControl.controls['leadTime'].value}} {{getLeadTimeTypeName(itemControl.controls['leadTimeType'].value) | lowercase}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Total Price</div>
                                                    <div class="text-primary">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value - itemControl.controls['discount'].value | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>


                                <ng-container *ngIf="isCustomQuote() && partItems?.controls" formArrayName="partLines">

                                    <!-- show as one product line -->
                                     <div class="flex flex-col gap-3 p-5">
                                        <div class="border-b flex gap-4 items-center pb-3">
                                            <div>Line: 1</div>
                                            <div>Product ID: {{customProductPartNumber}}</div>
                                            <div>Rev: 1</div>
                                        </div>

                                        <!-- <div class="text-lg">{{lookupPart(itemControl)?.description}}</div> -->

                                        <div>Specification:</div>
                                        <ul class="-mt-2 list-disc list-outside ml-6 flex flex-col">
                                            <li>Quotation for {{customProductName}}</li>
                                            <li>Product Code: {{customProductPartNumber}}</li>
                                            <li>Manufactured to industrial standards</li>
                                            <li>Quality controlled and tested prior to dispatch</li>
                                            <li>Full technical documentation included</li>
                                            <li>Supplied with material certificates and test reports</li>
                                        </ul>

                                        <div class="flex gap-8 px-6 py-3 bg-gray-50 mt-1">
                                            <div>
                                                <div class="mb-1">Quantity</div>
                                                <div>1</div>
                                            </div>
                                            <div>
                                                <div class="mb-1">U/M</div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="mb-1">Unit Price</div>
                                                <div>{{getTotalPrice() | currency:'GBP'}}</div>
                                            </div>

                                            <ng-container *ngFor="let itemControl of partItems?.controls; let i = index; let first = first;" [formGroupName]="i">
                                                <div *ngIf="first">
                                                    <div class="mb-1">Lead Time</div>
                                                    <div>{{itemControl.controls['leadTime'].value}} {{getLeadTimeTypeName(itemControl.controls['leadTimeType'].value) | lowercase}}</div>
                                                </div>
                                            </ng-container>

                                            <div>
                                                <div class="mb-1">Total Price</div>
                                                <div class="text-primary">{{getTotalPrice() | currency:'GBP'}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <ng-container *ngFor="let itemControl of partItems?.controls; let i = index" [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div class="border-b flex gap-4 items-center pb-3">
                                                <div>Line: {{i+1}}</div>
                                                <div>Part ID: {{lookupPart(itemControl)?.number}}</div>
                                                <div>Rev: 1</div>
                                            </div>

                                            <div class="text-lg">{{lookupPart(itemControl)?.description}}</div>

                                            <div>Specification:</div>
                                            <ul class="-mt-2 list-disc list-outside ml-6 flex flex-col">
                                                <li>Quotation for {{lookupPart(itemControl)?.description}}</li>
                                                <li>Product Code: {{lookupPart(itemControl)?.number}}</li>
                                                <li>Manufactured to industrial standards</li>
                                                <li>Quality controlled and tested prior to dispatch</li>
                                                <li>Full technical documentation included</li>
                                                <li>Supplied with material certificates and test reports</li>
                                            </ul>

                                            <div class="flex gap-8 px-6 py-3 bg-gray-50 mt-1">
                                                <div>
                                                    <div class="mb-1">Quantity</div>
                                                    <div>{{itemControl.controls['quantity'].value}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Unit Price</div>
                                                    <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Lead Time</div>
                                                    <div>{{itemControl.controls['leadTime'].value}}</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">Total Price</div>
                                                    <div class="text-primary">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value | currency:'GBP'}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container> -->
                                </ng-container>
                            </form>
                        </div>

                        <div *ngIf="summaryForm" class="flex justify-end mx-4">
                            <div class="divide-y py-4 px-6 flex flex-col">
                                <div class="flex justify-between py-2 text-lg gap-18">
                                    <div>Subtotal:</div>
                                    <div>{{getTotalPrice() * getMarginModifier() | currency:'GBP'}}</div>
                                </div>
                                <div class="flex justify-between py-2 text-lg gap-18">
                                    <div>Freight:</div>
                                    <div>{{summaryForm.controls['freightCost'].value | currency:'GBP'}}</div>
                                </div>
                                <div class="flex justify-between py-2 text-lg gap-18">
                                    <div>VAT ({{summaryForm.controls['vatRate'].value * 100}}%):</div>
                                    <div>{{getTotalPrice() * getMarginModifier() * summaryForm.controls['vatRate'].value | currency:'GBP'}}</div>
                                </div>
                                <div class="flex justify-between py-2 text-2xl gap-18">
                                    <div>Total (inc VAT):</div>
                                    <div class="text-primary">
                                        {{ getTotalPrice() * getMarginModifier() * (1 + summaryForm.controls['vatRate'].value) + summaryForm.controls['freightCost'].value | currency:'GBP' }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="border-b"></div>
                        
                        <div class="flex flex-col gap-4 mx-4">
                            <div class="uppercase">Notes</div>
                            <div>Customer requires ATEX certification and CE marking</div>

                            <div class="p-6 bg-gray-50 mt-4">
                                <div>
                                    This quotation is valid for 30 days from the date of issue. Prices are subject to change after this period.
                                </div>
                            </div>
                        </div>

                        <footer><img src="assets/dlm-images/dlm/dlm-footer-landscape.png" /></footer>
                    </div>



                    <div class="flex justify-between gap-4">
                        <button
                            mat-stroked-button
                            matStepperPrevious
                            type="button">
                            Back
                        </button>
                        <button
                            *ngIf="!dealId || deal?.isWizardInProgress"
                            class="ml-auto"
                            (click)="save(true, true)"
                            mat-stroked-button
                            type="button">
                            Save Progress
                        </button>
                        <button
                            [class.ml-auto]="!(!dealId || deal?.isWizardInProgress)"
                            mat-flat-button
                            (click)="downloadPdf()"
                            type="button"
                            [color]="'primary'">
                            Download
                        </button>
                        <button
                            mat-flat-button
                            (click)="save(false, true)"
                            type="button"
                            [color]="'primary'">
                            Send Quote
                        </button>
                    </div>
                </div>
            </mat-step>

        </mat-horizontal-stepper>


    </div>

    <!-- Divider -->
    <!-- <div class="my-6 border-t"></div> -->

    <!-- Actions -->
    <!-- <div class="flex flex-row items-between w-full gap-4">
        <div class="flex items-center justify-end ml-auto gap-4">
            <button
                (click)="close()"
                mat-stroked-button
                type="button">
                Cancel
            </button>
            
            <button
                (click)="save()"
                mat-flat-button
                type="button"
                [color]="'primary'"
                [disabled]="!form?.valid">
                <mat-icon class="icon-size-4 mr-1" svgIcon="feather:send"></mat-icon>
                <span class="ml-1">Submit RMA Request</span>
            </button>
        </div>
    </div> -->

</div>



<!-- Print stuff -->
<div id="print-header" style="display: none;">
  <img class="pt-8 px-8" src="assets/dlm-images/dlm/dlm-header.png" />
</div>

<div id="print-footer" style="display: none;">
  <img class="p-8" src="assets/dlm-images/dlm/dlm-footer-landscape.png" />
</div>
